import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import SelectInput from '@/common/components/SelectInput';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import useSearchBox from '../hooks/useSearchBox';

const SearchBox = ({ handleSearchCallback }) => {
	const hook = useSearchBox({ handleSearchCallback });

	return (
		<SearchBarCenter>
			<div>
				<SelectInput
					multiple={true}
					color={Colors.darkBlue}
					name='Market'
					options={hook.markets}
					width={200}
					setSelected={hook.setSelectedMarkets}
					selected={hook.selectedMarkets}
				/>
				<SelectInput
					multiple={true}
					color={Colors.darkBlue}
					name='Consultant'
					options={hook.consultants}
					width={200}
					setSelected={hook.setSelectedConsultants}
					selected={hook.selectedConsultants}
				/>
			</div>
			<SelectInput
				color={Colors.darkBlue}
				name='Result'
				options={hook.results}
				width={200}
				setSelected={hook.setSelectedResult}
				selected={hook.selectedResult}
			/>
			<ActionButton text='Search' onClick={(e) => hook.handleSearch(e)} />
		</SearchBarCenter>
	);
};

export default SearchBox;
